// extracted by mini-css-extract-plugin
export var advantages = "advantages-module--advantages--lT41D";
export var advantages__item = "advantages-module--advantages__item--SchtK";